import { render, staticRenderFns } from "./EditAppDialog.vue?vue&type=template&id=8252ba3c&"
import script from "./EditAppDialog.vue?vue&type=script&lang=js&"
export * from "./EditAppDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports